import { useEffect, useState } from 'react';
import { AiPromptModalBody } from '~/components/AiPromptForm/index.client';

import LoadingAnimation from '~/components/LoadingAnimation';
import type { LoaderFunctionArgs } from '@remix-run/node';

import { json } from '@remix-run/node';
import { prompts } from '~/services/index';
import { useSetApplicationContext } from '~/components/ApplicationContext';
import { useLoaderData } from '@remix-run/react';

export async function loader(args: LoaderFunctionArgs) {
    const promptId = args.params.promptId;
    const prompt = prompts.find((p) => p.id === promptId);

    if (!prompt) {
        throw new Response(`Can not find prompt with id ${promptId}`, {
            status: 404,
        });
    }

    return json({
        promptId,
        prompt,
    });
}

export default function Index() {
    const { prompt } = useLoaderData();
    const [isFetching, setFetching] = useState(true);
    const setApplicationContext = useSetApplicationContext();

    useEffect(() => {
        async function initialize() {
            try {
                setApplicationContext({
                    account: null,
                    host: 'iframe',
                    platform: 'web',
                });
                setFetching(false);
            } catch (err) {
                console.error(err);
                return;
            }
        }

        initialize();
    }, [setApplicationContext]);

    if (isFetching) {
        return (
            <div className='h-full w-full'>
                <LoadingAnimation />
            </div>
        );
    }
    return (
        <div className='my-8'>
            <AiPromptModalBody aiTemplate={prompt} isFreeMode={true} />
        </div>
    );
}
